import { CardMembership } from "@mui/icons-material";
import { HighlightCard } from "./Highlights";

export const SeriesMembershipsOpen = ({ organisation, openSeries }) => openSeries.map(series =>
    <HighlightCard
        key={series.id}
        backgroundColor={theme => theme.palette.highlights.membership_open}
        text="Membership"
        icon={<CardMembership fontSize="inherit" />}
        name={series.name}
        to={`/${organisation.shortName}/series/${series.id}/sign-on`}
    />
);
